/* GG - Suggestions de recherche qui completent la saisie */
(function () {
var QUOTES = new RegExp('[' + String.fromCharCode(8216, 8217, 700, 96) + ']', 'g');
var DASHES = new RegExp('[' + String.fromCharCode(8211, 8212) + ']', 'g');
function norm(s) { return (s || '').replace(QUOTES, "'").replace(/\s+/g, ' ').trim(); }
function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function bold(text, q) {
var i = text.toLowerCase().indexOf(q.toLowerCase());
if (i < 0) return esc(text);
return esc(text.slice(0, i)) + '<b>' + esc(text.slice(i, i + q.length)) + '</b>' + esc(text.slice(i + q.length));
}
function clean(title) {
var t = norm(title).replace(DASHES, '-').split(/\s-\s|\s\(|\s\d+\s?(g|ml|cl|l)\b/i)[0];
return t.replace(/[!?,;:*"]/g, '').trim();
}
function build(root, input) {
var q = norm(input.value).toLowerCase();
if (q.length < 2) return; var pl = root.querySelector('.gg-mas-search__product-list'); if (pl) { var sc = function (el) { var t = norm((el.querySelector('.gg-mas-search__product-title') || el).textContent).toLowerCase(); return t.indexOf(q) === 0 ? 0 : ((' ' + t).indexOf(' ' + q) >= 0 ? 1 : 2); }; [].slice.call(pl.children).map(function (el, i) { return [sc(el), i, el]; }).sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }).forEach(function (x) { pl.appendChild(x[2]); }); }
var seen = {}, out = [];
function add(s) {
s = norm(s).toLowerCase();
if (!s || s === q || seen[s] || s.length > 40) return;
var words = s.split(' ');
var ok = s.indexOf(q) === 0 || words.some(function (w) { return w.indexOf(q) === 0; });
if (!ok || /\s(the|de|la|le|les|des|du|et|au|aux|a|with|of|and)$/.test(s)) return;
seen[s] = 1; out.push(s);
}
root.querySelectorAll('.gg-mas-search__query-item:not([data-gg])').forEach(function (a) { seen[norm(a.textContent).toLowerCase()] = 1; });
root.querySelectorAll('.gg-mas-search__extra a').forEach(function (a) { add(a.textContent); });
var titles = [];
root.querySelectorAll('.gg-mas-search__product-title').forEach(function (el) { titles.push(clean(el.textContent).split(' ')); });
titles.forEach(function (w) { if (w.length >= 2) add(w.slice(0, 2).join(' ')); });
titles.forEach(function (w) { if (w.length >= 3) add(w.slice(0, 3).join(' ')); });
out = out.slice(0, 5);
var queries = root.querySelector('.gg-mas-search__queries');
if (!queries) {
if (!out.length) return;
queries = document.createElement('div');
queries.className = 'gg-mas-search__queries';
queries.innerHTML = '<p class="gg-mas-search__heading">Suggestions</p><div class="gg-mas-search__query-list"></div>';
root.insertBefore(queries, root.firstChild);
}
var list = queries.querySelector('.gg-mas-search__query-list');
list.querySelectorAll('.gg-mas-search__query-item:not([data-gg])').forEach(function (a) {
if (!a.querySelector('b')) a.innerHTML = bold(norm(a.textContent), q);
});
var total = list.querySelectorAll('.gg-mas-search__query-item').length;
out.forEach(function (s) {
if (total >= 5) return;
var a = document.createElement('a');
a.className = 'gg-mas-search__query-item';
a.setAttribute('data-gg', '1');
a.href = '/search?q=' + encodeURIComponent(s) + '&type=product';
a.innerHTML = bold(s, q);
list.appendChild(a);
total++;
});
}
function init() {
document.querySelectorAll('[data-gg-mas-search]').forEach(watch);
}
function watch(wrap) {
var input = wrap.querySelector('.gg-mas-search-form__input');
var root = wrap.querySelector('[id^="gg-mas-predictive-results"]');
if (!input || !root) return;
var busy = false;
var obs = new MutationObserver(function () {
if (busy) return;
busy = true;
try { build(root, input); } catch (e) {}
setTimeout(function () { busy = false; }, 0);
});
obs.observe(root, { childList: true });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
